import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type ThemeMode = 'dark' | 'light' | 'system';

interface AppUiState {
  commandOpen: boolean;
  focusMode: boolean;
  sidebarCollapsed: boolean;
  theme: ThemeMode;
  setCommandOpen: (open: boolean) => void;
  setFocusMode: (active: boolean) => void;
  setSidebarCollapsed: (collapsed: boolean) => void;
  setTheme: (theme: ThemeMode) => void;
}

export const useAppStore = create<AppUiState>()(
  persist(
    (set) => ({
      commandOpen: false,
      focusMode: false,
      sidebarCollapsed: false,
      theme: 'dark',
      setCommandOpen: (commandOpen) => set({ commandOpen }),
      setFocusMode: (focusMode) => set({ focusMode }),
      setSidebarCollapsed: (sidebarCollapsed) => set({ sidebarCollapsed }),
      setTheme: (theme) => set({ theme })
    }),
    {
      name: 'discipline-ui',
      partialize: ({ sidebarCollapsed, theme }) => ({ sidebarCollapsed, theme })
    }
  )
);

export function applyTheme(theme: ThemeMode): void {
  const dark =
    theme === 'dark' ||
    (theme === 'system' && window.matchMedia('(prefers-color-scheme: dark)').matches);
  document.documentElement.classList.toggle('dark', dark);
  document.documentElement.style.colorScheme = dark ? 'dark' : 'light';
  document
    .querySelector('meta[name="theme-color"]')
    ?.setAttribute('content', dark ? '#0b0d10' : '#f6f7f9');
}
